import { Typography, UnstyledButton } from '@capsule/consumer-design-system';

import styled from 'styled-components';
import InlineSVG from 'svg-inline-react';

import { FormikTextField } from '../../Form/FormikTextField/FormikTextField';

export const ContentContainer = styled.div`
  max-width: 580px;
  margin: 0 auto;
  ${props => props.theme.mediaQueries.smallDown} {
    padding-bottom: ${({ theme }) => theme.space.s7};
  }
`;

export const ConfirmContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: ${({ theme }) => theme.space.s3};
  margin-bottom: ${({ theme }) => theme.space.s4};
`;

export const ConfirmIconContainer = styled.div`
  flex: 0;
  margin-top: -1px;
`;
export const ConfirmTextContainer = styled.div`
  flex: 1 1 auto;
`;

export const StyledInlineSvg = styled(props => <InlineSVG {...props} />)`
  svg {
    width: ${props => props.size}px !important;
    height: ${props => props.size}px !important;
    fill: ${({ theme }) => theme.colors.capsuleBlue50};
  }
`;

export const StyledMedCard = styled.div`
  padding: ${({ theme }) => theme.space.s4};
  border-radius: ${({ theme }) => theme.radii.r100};
  box-shadow: 0px 2px 6px 0px rgba(153, 191, 188, 0.24), 0px 0px 1px 0px rgba(110, 120, 129, 0.16);
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.space.s2};
  margin-bottom: ${({ theme }) => theme.space.s4};
  background-color: ${({ theme }) => theme.colors.white};
`;

export const FauxLabel = styled(Typography)<{ isFocused: boolean; hasError: boolean }>`
  color: ${({ theme, hasError }) => (!hasError ? theme.colors.capsuleGreen60 : theme.colors.capsuleRed60)};
`;

export const TextFieldTransparentButton = styled(UnstyledButton)`
  position: absolute;
  width: ${({ theme }) => theme.space.s7};
  height: ${({ theme }) => theme.space.s7};
  background-color: ${({ theme }) => theme.colors.transparent};
  z-index: ${({ theme }) => theme.zIndex.z2};
  top: -${({ theme }) => theme.space.s4};
`;

export const FormikTextFieldWithTextareaStyles = styled(FormikTextField)`
  width: 100%;
  border-radius: ${({ theme }) => theme.radii.r100};
  padding: ${({ theme }) => theme.space.s4};
  box-sizing: border-box;
  display: flex;
  flex-grow: 1;

  &&& {
    border: 1px solid;

    border-color: ${({ theme }) => theme.colors.capsuleGreen60};
    color: ${({ theme }) => theme.colors.capsuleBlue50};
    outline-color: ${({ theme }) => theme.colors.capsuleGreen60};

    &::placeholder {
      color: ${({ theme }) => theme.colors.capsuleGray50};
    }

    &:focus {
      outline: solid 1px !important;
      outline-color: ${({ theme }) => theme.colors.capsuleGreen60} !important;
    }

    &[aria-invalid='true'] {
      border-color: ${({ theme }) => theme.colors.capsuleRed60};
      color: ${({ theme }) => theme.colors.capsuleRed60};
      outline-color: ${({ theme }) => theme.colors.capsuleRed60} !important;
    }
  }
`;

export const DemoEducationContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.space.s2};
  ${props => props.theme.mediaQueries.small} {
    flex-direction: row;
    gap: ${({ theme }) => theme.space.s4};
  }
`;

export const DemoEducationCard = styled.div`
  display: flex;
  flex-direction: row;
  padding: ${({ theme }) => theme.space.s4};
  background-color: ${({ theme }) => theme.colors.capsuleGray00};
  border-radius: ${({ theme }) => theme.radii.r200};
  gap: ${({ theme }) => theme.space.s5};
  align-items: center;
  ${props => props.theme.mediaQueries.small} {
    flex-direction: column;
    gap: ${({ theme }) => theme.space.s2};
    justify-content: center;
    text-align: center;
    padding: ${({ theme }) => theme.space.s3};
    flex: 1 1 33%;
  }
  & svg {
    width: 60px !important;
    height: 60px !important;
    ${props => props.theme.mediaQueries.small} {
      height: auto !important;
    }
  }
`;

export const DemoEducationTags = styled(Typography)`
  color: ${({ theme }) => theme.colors.capsuleBlue60};
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.radii.r300};
  box-shadow: ${({ theme }) => theme.shadows.dp2};
  padding: ${({ theme }) => theme.space.s1} ${({ theme }) => theme.space.s2};
  display: inline-flex;
  margin: 2px;
  font-size: 1rem !important;
`;

export const Lowercase = styled.span`
  text-transform: lowercase;
`;
export const Capitalize = styled.span`
  text-transform: capitalize;
`;
